<svelte:options tag="eas-tile" />

<script type="ts">
    import { createEventDispatcher } from "svelte";
    import { get_current_component } from "svelte/internal";

    const svelteDispatch = createEventDispatcher();
    const component = get_current_component();

    const dispatch = (name: string, data: any, event: any) => {
        svelteDispatch(name, data);
        component.dispatchEvent && component.dispatchEvent(event);
    };

    export let menukey='';
    export let iconstyle = "";
    export let url = "";
    export let id = "";
    export let title = "Tile 1";
    export let description =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum turpis lorem, luctus pellentesque sapien et, dictum dapibus orci. Praesent quis augue placerat, vulputate arcu in, fermentum nisl. Morbi consequat magna non neque eleifend aliquet. Vestibulum aliquet hendrerit ante. Vivamus laoreet est tempus tellus lobortis, lobortis feugiat dui faucibus. Pellentesque ac tincidunt nibh. Donec eu sollicitudin orci.";
    export let buttonTitle = "Open";
    export let data = {};

    function onClick(e, data) {
        e.stopPropagation();
        dispatch(
            "click",
            data,
            new CustomEvent("click", { ...e, detail: data })
        );
    }
</script>

<!-- <div id={menukey} on:click={(e) => onClick(e, menukey)}> -->
   <a href="javascript:void(0)" class="a--tile white hover--shadow" style="border-radius:calc(8px)"> 
    <div class="tile-content">

      <div class="tile--img">
       <div class="img--position">
                <img src="assets/dist/assets/svg/{iconstyle}.svg" />
         </div> 
      </div>
      <div class="tile--content">
        <header class="header--tile">
          <div class="tile--title">{title}</div>
        </header>
          <p class="p--tile">
            {description} 
          </p>
      </div>
    </div>
   </a>
<!-- </div> --> 

<style>
  .a--tile {
    display: block;
    position: relative;
    align-items: center;
    height: auto;
    overflow: hidden;
    color: black;
    text-decoration: none;
    font-family: "Source Sans Pro", sans-serif;
    -webkit-font-smoothing: antialiased;
    outline: 2px solid transparent;
    transition: all 0.2s ease-in-out;
    border: 1px solid #d8d8d8;
  }
  .a--tile:focus {
    outline: 2px solid #000;
    border: 1px solid #000;
  }
  .tile-content {
    display: flex;
  }
  .white {
    background: #fff;
  }
  .hover--shadow:hover {
    box-shadow: 0px 0 32px -10px rgb(0 0 0 / 18%);
  }
  .tile--img {
    height: 100%;
    width: 100%;
    max-width: 100px;
    min-height: 120px;
    position: relative;
    top: 0;
    background-color: #5079a4;
  }
  .img--position {
    margin: auto;
    transform: translateY(50%);
    text-align: center;
    width: 45px;
  }
  .tile--content {
    padding: 0 20px;
    position: relative;
    /* margin: auto; */
    transform: translateY(45%);
    width: 100%;
    height: 100%;
  }
  .tile--title {
    font-size: 18px;
    line-height: 25px;
  }
  .p--tile {
    margin: 5px 0 0 0;
    font-size: 14px;
  }
  @media (max-width: 1440px) {
    .tile--content {
      transform: translateY(5%);
    }
  }
  @media (max-width: 1024px) {
    .tile--content {
      transform: translateY(20%);
    }
  }
  @media (max-width: 425px) {
    .p--tile {
      height: 50px;
      overflow: hidden;
    }
    .tile--title {
      font-size: 17px;
      line-height: 20px;
    }
    .tile--content {
      transform: translateY(7%);
    }
  }
</style>
